import React, { useEffect, useState } from 'react';
import { ListVideo, ShieldAlert, CheckCircle, Loader2 } from 'lucide-react';
import api from '../../services/api';

const typeLabel = (t) => ({
  change_list: 'Changement de liste',
  toggle_adult: 'Contenu adulte',
  both: 'Liste + adulte',
}[t] || t);

export const ContentChangeRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resolving, setResolving] = useState(null);

  const load = async () => {
    try {
      const res = await api.get('/admin/content-change-requests?status=pending');
      setRequests(res.data?.requests || []);
    } catch (e) {
      // silencieux
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const resolve = async (id) => {
    setResolving(id);
    try {
      await api.post(`/admin/content-change-requests/${id}/resolve`);
      setRequests((prev) => prev.filter((r) => r.id !== id));
    } catch (e) {
      // noop
    } finally {
      setResolving(null);
    }
  };

  if (loading || requests.length === 0) return null;

  return (
    <div className="bg-[#1A1A1D] p-4 sm:p-6 rounded-lg metallic-border mb-6 sm:mb-8 border border-[#FFB800]/30" data-testid="content-change-requests">
      <h2 className="text-lg sm:text-xl font-bold text-white mb-4 flex items-center gap-2">
        <ListVideo className="h-5 w-5 text-[#FFB800]" />
        Demandes de modification de contenu
        <span className="text-xs bg-[#FFB800] text-black px-2 py-0.5 rounded-full">{requests.length}</span>
      </h2>
      <div className="space-y-2">
        {requests.map((r) => (
          <div key={r.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 bg-[#222226] rounded-lg p-3" data-testid={`ccr-${r.id}`}>
            <div className="text-sm">
              <span className="text-white font-semibold">{r.user_email}</span>
              <span className="ml-2 text-[10px] bg-[#FF6B35]/20 text-[#FF6B35] px-2 py-0.5 rounded-full">{typeLabel(r.request_type)}</span>
              <div className="text-[#B8B8BA] text-xs mt-1">
                {r.desired_template_name && <span className="mr-3">→ {r.desired_template_name}</span>}
                {r.desired_is_adult !== null && r.desired_is_adult !== undefined && (
                  <span className="inline-flex items-center gap-1"><ShieldAlert className="h-3 w-3 text-[#FF3B5C]" />{r.desired_is_adult ? 'activer adulte' : 'désactiver adulte'}</span>
                )}
                {r.message && <span className="block text-[#6B6B6E] italic mt-0.5">"{r.message}"</span>}
              </div>
            </div>
            <button
              onClick={() => resolve(r.id)}
              disabled={resolving === r.id}
              className="bg-[#00FF88]/15 border border-[#00FF88]/40 text-[#00FF88] px-3 py-1.5 rounded-lg text-xs font-semibold flex items-center justify-center gap-1 hover:bg-[#00FF88]/25 transition-colors disabled:opacity-50 shrink-0"
              data-testid={`resolve-ccr-${r.id}`}
            >
              {resolving === r.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CheckCircle className="h-3.5 w-3.5" />}
              Marquer traité
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentChangeRequests;
